import "./App.scss";
import React from "react";
import Marketplace from "./Components/Marketplace/Marketplace";
import Data from "./Data/data.json";
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null,
    };
  }
  render() {
    var data = Data.Marketplaces.filter((value) => value.Active);
    if (Array.isArray(data)) {
      data = data.sort((a, b) => {
        const aVal = a[this.props.sortValue];
        const bVal = b[this.props.sortValue];
        if (aVal < bVal) return -1;
        if (aVal > bVal) return 1;
        return 0;
      });
    }
    return <Marketplace jsonData={data} filtered={data} />;
  }
}

export default App;
